import * as canvas2d from './canvas2d/index.js'
import * as three from './three/index.js'

export const backends = { canvas2d, three }
export const backendOptions = [
  { value: 'canvas2d', label: canvas2d.label },
  { value: 'three', label: three.label, disabled: true },
]
